var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1085",
    "data-name": "Group 1085",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.95,
    height: 24.702,
    viewBox: "0 0 16.95 24.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M96.933,1a6.9,6.9,0,0,0-3.649-1A16.526,16.526,0,0,0,88.6.926a15.238,15.238,0,0,1-4.267.865h0a5.5,5.5,0,0,1-2.552-.6V.724a.724.724,0,1,0-1.447,0V23.978a.724.724,0,1,0,1.447,0V12.614a6.992,6.992,0,0,0,2.552.461,16.524,16.524,0,0,0,4.683-.926,15.233,15.233,0,0,1,4.267-.865,5.489,5.489,0,0,1,2.9.792.724.724,0,0,0,1.1-.621V1.619A.724.724,0,0,0,96.933,1Z",
    transform: "translate(-80.334)",
    fill: "#3f2566"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFact2);
export default __webpack_public_path__ + "static/media/fact2.819663ba53c3a54e3b9c2b741f691203.svg";
export { ForwardRef as ReactComponent };